export default __webpack_public_path__ + "static/media/640_portfolio03-nl-web.a1934b1c.png";